import {round} from "./utils/money";
import {polishPlurals} from 'polish-plurals';
import moment from 'moment';

export const helpers = {
    calculatePercentage(given, wanted) {
        return (given / wanted) * 100;
    },
    indicatorClass(given, wanted) {
        const percentage = this.calculatePercentage(given, wanted);

        if (percentage > 110) {
            return 'nutrients--red';
        }

        if (percentage <= 110 && percentage >= 90) {
            return 'nutrients--green';
        }

        return 'nutrients--primary';
    },
    calculateTargetWeightDate(initialWeight, targetWeight, weightChangePerWeek) {
        if (initialWeight && targetWeight && weightChangePerWeek) {
            const weightChange = Math.abs(round(initialWeight - targetWeight, 2));
            if (weightChange > 0) {
                const weeks = round(weightChange / weightChangePerWeek, 0);
                const weightChangeTargetDate = moment().add(weeks, 'w');
                let weightChangeTargetDateLabel = `${weightChangeTargetDate.format('DD.MM.YYYY')}`;
                if (weeks > 0) {
                    weightChangeTargetDateLabel = `${weeks} ${polishPlurals('tydzień', 'tygodnie', 'tygodni', weeks)} - ` + weightChangeTargetDateLabel;
                }
                return weightChangeTargetDateLabel;
            } else {
                return null;
            }
        } else {
            return null;
        }
    },
    calculateBmrByHarrisBenedict(sex, weight, height, age) {
        if (sex && weight && height && age) {
            if (sex === 'female') {
                return round(655.1 + (9.563 * weight) + (1.85 * height) - (4.676 * age), 0);
            } else {
                return round(66.5 + (13.75 * weight) + (5.003 * height) - (6.775 * age), 0);
            }
        }
        return null;
    },
    calculateBmrByMifflin(sex, weight, height, age) {
        if (sex && weight && height && age) {
            if (sex === 'female') {
                return round((10 * weight) + (6.25 * height) - (5 * age) - 161, 0);
            } else {
                return round((10 * weight) + (6.25 * height) - (5 * age) + 5, 0);
            }
        } else {
            return null;
        }
    },
    calculateTmrByHarrisBenedict(sex, weight, height, age, activity, psychologicalCondition) {
        if (activity && sex) {
            let bmr = this.calculateBmrByHarrisBenedict(sex, weight, height, age);
            return this.calculateTmr(bmr, activity, sex, psychologicalCondition);
        } else {
            return null;
        }
    },
    calculateTmrByMifflin(sex, weight, height, age, activity, psychologicalCondition) {
        if (activity && sex) {
            let bmr = this.calculateBmrByMifflin(sex, weight, height, age);
            return this.calculateTmr(bmr, activity, sex, psychologicalCondition);
        } else {
            return null;
        }
    },
    calculateTmr(bmr, activity, sex, psychologicalCondition) {
        const activityMap = {
            1: 1.3,
            2: 1.4,
            3: 1.6,
            4: 1.75,
            5: 2,
            6: 2.2
        };
        const activityValue = activityMap[activity];
        bmr *= activityValue;

        if (sex === 'female') {
            if (psychologicalCondition === 2) {
                bmr += 360;
            } else if (psychologicalCondition === 3) {
                bmr += 475;
            } else if (psychologicalCondition === 4) {
                bmr += 505;
            }
        }

        return round(bmr, 0);
    },
    deepClone(value) {
        return JSON.parse(JSON.stringify(value));
    }
};
